// extracted by mini-css-extract-plugin
module.exports = {"warning":"DuplicateIdsWarning_warning__6a3_C","lenkeInline":"DuplicateIdsWarning_lenkeInline__9ES7e"};